import React from 'react';
import { cn } from '../../lib/cn';
import {
  parseCreditBalance,
  subscribeCreditBalance,
  type CreditBalance,
} from '../../services/credits';

interface CreditBadgeProps {
  userId?: string;
  className?: string;
  compact?: boolean;
  label?: string;
  forceLabel?: boolean;
  showReservation?: boolean;
}

const EMPTY_BALANCE: CreditBalance = parseCreditBalance(null);

export function CreditBadge({
  userId,
  className,
  compact = false,
  label = 'Hak',
  forceLabel = false,
  showReservation = true,
}: CreditBadgeProps) {
  const [balance, setBalance] = React.useState<CreditBalance>(EMPTY_BALANCE);

  React.useEffect(() => {
    if (!userId) {
      setBalance(EMPTY_BALANCE);
      return;
    }

    const unsubscribe = subscribeCreditBalance(
      userId,
      (next) => setBalance(next),
      (error) => {
        console.error('[CreditBadge] bakiye okunamadi', error);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  if (!userId) {
    return null;
  }

  const title = `Kalan hak: ${balance.bakiye} | Rezerve: ${balance.rezervasyon}`;

  const shouldShowLabel = label.length > 0 && (!compact || forceLabel);

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-xl border border-emerald-200/80 bg-emerald-50/85 px-3 py-1.5 text-emerald-800 shadow-sm',
        compact && 'px-2.5 py-1',
        className
      )}
      title={title}
      aria-label={title}
    >
      <span className="inline-flex h-2 w-2 rounded-full bg-emerald-500" />
      {shouldShowLabel && (
        <span className="text-[11px] font-semibold uppercase tracking-[0.08em]">{label}</span>
      )}
      <span className="text-sm font-bold leading-none">{balance.bakiye}</span>
      {showReservation && balance.rezervasyon > 0 && (
        <span className="text-[11px] font-medium text-emerald-700/90">rez: {balance.rezervasyon}</span>
      )}
    </div>
  );
}
